import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightSmallGrey = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 15,
	viewBox: "0 0 23 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 7.5H22M22 7.5L15.5 1M22 7.5L15.5 14",
		stroke: "#A3B8C2",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowRightSmallGrey;
